// extracted by mini-css-extract-plugin
export default {"option":"productSelectField_option__GSwsa","stock":"productSelectField_stock__GUdWF","noStock":"productSelectField_noStock__6CrAH"};